import { TabletOutlined, WhatsAppOutlined } from '@ant-design/icons'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { ConditionalLinkWrapper } from '@supplement-bacon/react-toolkit/utils'
import { Space, Tag } from 'antd'
import { Venue as VenueModel } from '../../models/Venue'
import { useTenant } from '../../modules/tenant/contexts/tenant/TenantContext'
import { useAppSelector } from '../../store/hooks'
import { selectVenueById } from '../../store/VenueReducer'
import { Permission } from '../../utils/permissions'
import { useHasAccess } from '../HasAccess'

type Props = SBModelComponent<VenueModel> & {
  linkToDetail?: boolean
}

export const BookingOverview = ({ id, model, linkToDetail = false }: Props) => {
  const { allPlatforms } = useTenant()
  const venue = model ? model : useAppSelector(selectVenueById(id!))
  const { hasAccess } = useHasAccess()

  if (!venue) {
    return <></>
  }

  return (
    <ConditionalLinkWrapper
      to={`/venues/${venue.slug}/booking`}
      condition={linkToDetail && hasAccess(Permission.updateVenue)}
      onClick={() => {}}
      wrapper={(children) => children}
    >
      <Space wrap>
        <Tag
          icon={<TabletOutlined />}
          color={venue.booking?.app?.enable ? 'green' : 'orange'}
        >
          {allPlatforms.ios.name} & {allPlatforms.android.name}
        </Tag>
        <Tag
          color={venue.booking?.chatbot?.enable ? 'green' : 'orange'}
          icon={<WhatsAppOutlined />}
        >
          {allPlatforms.whatsapp.name}
        </Tag>
      </Space>
    </ConditionalLinkWrapper>
  )
}

export type BookingOverviewType = {
  BookingOverview: typeof BookingOverview
}
